import { AiFillBank, AiFillCar, AiOutlineFundProjectionScreen } from "react-icons/ai";
import { BiBrain, BiPurchaseTagAlt, BiTimeFive } from "react-icons/bi";
import { BsBook, BsCashCoin, BsFillHouseDoorFill, BsTools, BsTruck } from "react-icons/bs";
import { FaHandHolding, FaRegFilePowerpoint, FaRegUser, FaWarehouse } from "react-icons/fa";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { MdAttachMoney, MdOutlineInventory2, MdOutlinePayments, MdPointOfSale } from "react-icons/md";
import { RiAdminLine, RiCustomerServiceLine, RiOrganizationChart, RiProductHuntLine, RiShip2Line } from "react-icons/ri";
import { TbBuildingFactory } from "react-icons/tb";

const ModuleIcon = (props: { moduleno: string }) => {
  const { moduleno } = props;

  return (
    <>
      {
        moduleno == "SA" ? (
          <RiAdminLine size="16" />
        ) : moduleno == "OS" ? (
          <RiOrganizationChart size="16" />
        ) : moduleno == "GL" ? (
          <BsBook size="16" />
        ) : moduleno == "AP" ? (
          <FaHandHolding style={{ transform: "rotate(160deg)" }} size="16" />
        ) : moduleno == "AR" ? (
          <FaHandHolding size="16" />
        ) : moduleno == "EM" ? (
          <MdAttachMoney size="16" />
        ) : moduleno == "FA" ? (
          <AiFillCar size="16" />
        ) : moduleno == "PI" ? (
          <RiProductHuntLine size="16" />
        ) : moduleno == "SD" ? (
          <MdPointOfSale size="16" />
        ) : moduleno == "PA" ? (
          <AiOutlineFundProjectionScreen size="16" />
        ) : moduleno == "SM" ? (
          <RiCustomerServiceLine size="16" />
        ) : moduleno == "PC" ? (
          <TbBuildingFactory size="16" />
        ) : moduleno == "FF" ? (
          <BsTruck size="16" />
        ) : moduleno == "RE" ? (
          <BsFillHouseDoorFill size="16" />
        ) : moduleno == "TM" ? (
          <BiTimeFive size="16" />
        ) : moduleno == "FM" ? (
          <RiShip2Line size="16" />
        ) : moduleno == "EP" ? (
          <FaRegUser size="16" />
        ) : moduleno == "TC" ? (
          <HiOutlineReceiptTax size="16" />
        ) : moduleno == "PY" ? (
          <MdOutlinePayments size="16" />
        ) : moduleno == "WM" ? (
          <FaWarehouse size="16" />
        ) : moduleno == "CB" ? (
          <AiFillBank size="16" />
        ) : moduleno == "BU" ? (
          <BsCashCoin size="16" />
        ) : moduleno == "MP" ? (
          <BiBrain size="16" />
        ) : moduleno == "PS" ? (
          <BiPurchaseTagAlt size="16" />
        ) : moduleno == "IC" ? (
          <MdOutlineInventory2 size="16" />
        ) : moduleno == "PL" ? (
          <FaWarehouse size="16" />
        ) : moduleno == "PM" ? (
          <BsTools size="16" />
        ) : (
          <FaRegFilePowerpoint size="16" />
        )
      }
    </>
  )

}

export default ModuleIcon